import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { type MailRibbonControlId, type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import { createMailAppSplitButton } from "owa-mail-ribbon-utils/lib/createMailRibbonButton";
import { getControlInfo } from "owa-mail-ribbon-utils/lib/getControlInfo";
import { getRibbonMailboxInfo } from "owa-mail-ribbon-utils/lib/getRibbonMailboxInfo";
import { getSlrHeroAppSplitButtonStyles } from "owa-command-ribbon-styles";
import { onNewEmailSplitButtonExecuted, onNewMessage, onNewNoteClicked, onNewPost, } from "owa-mail-ribbon-command-actions/lib/commandActions";
import { createMoveControl } from "../../../util/createMoveControl";
import { onNewGroupMenuClicked } from "../../utils/deferredOnNewGroupMenuClicked";
import { resetMenuDefinitionMutator } from "../../../mutatorActions/menuDefinitionMutatorActions";
import { type MenuItemType } from "owa-filterable-menu/lib/components/MenuItemType";
import type { MenuOpenOnExecuteParameter, RibbonControlProps } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { constructKeytip } from "owa-command-ribbon";
import { getMailMenuItemShouldShow } from "owa-mail-filterable-menu-behavior";
import { getMenuDefinition } from "../../../store/menuDefinitionStore";
import { getPalette } from "owa-theme";
import { isPublicFolderSelected } from "owa-publicfolder-utils";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";

/**
 * This file contains the definitions for all the controls
 * in the Single Line Ribbon (SLR)
 */
export const getNewMessageControl: (keytipTabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps) => RibbonControlProps = owaComputedFn(function getNewMessageControl(keytipTabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps): RibbonControlProps {
    const id = 588;
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    const isNote: boolean = getMailMenuItemShouldShow(57, mailboxInfo);
    const isPublicFolder: boolean = isPublicFolderSelected();
    const { ariaText, iconName, text, tooltip } = getControlInfo(id, props);
    const storeName = "NewGroupMenuDefinitionStore";
    const useWin32Styles = isWin32StylingEnabled();
    
    return createMailAppSplitButton(id, text, ariaText, isNote ? undefined : tooltip, props, getMenuDefinition(storeName), isNote
        ? onNewNoteClicked
        : param => {
            isPublicFolder
                ? onNewPost(param?.event?.timeStamp)
                : onNewMessage(param?.event?.timeStamp);
        }, constructKeytip([keytipTabId], id, true /* hasMenu */), iconName, useWin32Styles ? undefined : getPalette().white, useWin32Styles ? undefined : getSlrHeroAppSplitButtonStyles(), undefined /*itemId*/, {
        onMenuButtonExecute: (parameter: MenuOpenOnExecuteParameter) => {
            onNewEmailSplitButtonExecuted(parameter, mailboxInfo);
            onNewGroupMenuClicked(keytipTabId, props);
        },
        onAfterMenuDismiss: () => {
            resetMenuDefinitionMutator(storeName);
        },
        primaryDisabled: !getMailMenuItemShouldShow(56, mailboxInfo) &&
            !getMailMenuItemShouldShow(57, mailboxInfo),
    }, !useWin32Styles /* isHero applies only when win32 styles are turned off */);
});

export const getMoveControl: (keytipTabId: MailRibbonTabId | undefined, props: ReadOnlyRibbonControlDefProps) => RibbonControlProps = owaComputedFn(function getMoveControl(keytipTabId: MailRibbonTabId | undefined, props: ReadOnlyRibbonControlDefProps): RibbonControlProps {
    return createMoveControl(keytipTabId, props, {
        isSLR: true,
        includeItemId: false,
    });
});
